import React from 'react';

import QuotaArcorSupervisors  from 'components/Tvendo/Sale/QuotaBPartner/Arcor/QuotaSupervisors/List.js';

export default function () {
  return <QuotaArcorSupervisors  />;
}
